<style lang="stylus">
    .hyperlink-content
        display flex
        padding-bottom 16px
        .hyperlink-left
            padding-bottom 64px
            .hyperlink-left-item
                position relative
                user-select none
                cursor pointer
                text-align center
                width 126px
                height 80px
                display flex
                flex-direction column
                justify-content center
                align-items center
                flex-wrap wrap
                border-radius: $box-radius;
                margin-bottom: 4px
                &:last-child
                    .item-icon
                        stroke var(--svg-color-gray-42-secondary)
                        fill transparent
                .item-icon
                    width 24px
                    height 24px
                    fill var(--svg-color-gray-42-secondary)
                    text-align center
                .left-text
                    text-align center
                    white-space nowrap
                    width 100%
                    color inherit
                    margin-top 8px
                    textOverflow()
                .active
                    color var(--text-color-hyper-link-left-item)
                    display block
                    text-align center
                    border-left none
                &:hover:not(.active)
                    color var(--text-color-hyper-link-left-item)
                    background-color: $main-hovercolor;
                    border-radius 6px
                    .item-icon
                        fill var(--themeColor)
                    &:last-child
                        .item-icon
                            fill transparent
                            stroke var(--themeColor)
            .active
                color var(--text-color-hyper-link-left-item)
                text-align center
                background $main-selectcolor
                border-radius 6px
                .item-icon
                    fill var(--themeColor)
                &:last-child
                    .item-icon
                        fill transparent
                        stroke var(--themeColor)
        .hyperlink-right
            flex 1
            padding-left 24px
            .ivu-select-arrow
                right 2px
            .hyperlink-right-item
                margin-bottom 16px
                display flex
                align-items center
                justify-content space-between
                &.hyperlink-right-item-en
                    label
                        min-width 70px
                .ivu-select-dropdown
                    .ivu-select-dropdown-list
                        .ivu-select-item
                            width 260px
                            overflow: hidden;
                            text-overflow: ellipsis;
                label
                    min-width 40px
                    font-size 12px
                    line-height 16px
                    margin-right 20px
                input
                    width 254px
                &.cloudFile-item
                    input
                        width 174px
                    .ivu-input-wrapper
                        width auto
                .btn
                    width 64px
                    height 24px
                    margin-left 16px
                    text-align center
                    line-height 22px
                    background var(--bg-color-tertiary)
                    border 1px solid var(--border-color-box-6)
                    box-shadow var(--box-shadow-color-small)
                    border-radius 6px
                    &:hover
                        background var(--themeColor)
                        color #fff
                    &.disable
                        background #fff
                        color rgba(0, 0, 0, 0.4)
            .hyperlink-list-box
                padding: 4px
                border 1px solid $box-bordercolor
                border-radius: $box-radius;
                height 120px
                overflow auto
                width 100%
                height 124px
                padding 4px 6px
                overflow auto
                border 1px solid var(--border-color-box-6)
                border-radius 6px
                .hyperlink-list-item
                    border-radius: 4px
                    width 100%
                    padding 0 10px
                    cursor pointer
                    overflow hidden
                    text-overflow ellipsis
                    white-space nowrap
                    line-height 28px
                    height 28px
                    &:hover:not(.select)
                        background $main-hovercolor
                .select
                    background $main-hovercolor
                    border-radius 6px
            .hyperlink-toolbox
                margin-top 8px
                >div
                    float left
                    width 24px
                    height 24px
                    border-radius 3px
                    user-select none
                    cursor pointer
                    .item-icon
                        color var(--svg-color-gray-42-secondary)
                        width 23px
                        height 23px
                    &:first-child
                        margin-right 15px
                    &:hover
                        background-color $main-hovercolor
                        border-radius 6px
            .hyperlink-container-btn
                display flex
                justify-content flex-end
                margin-top 20px
                div
                    border-radius 4px
                    padding 6px 22px
                    margin-left 10px
                    border 1px solid var(--border-color-hyperlink-container-btn)
                    cursor pointer
    .hyperlink-container
        position absolute
        left 50%
        top 50%
        width 602px
        height 460px
        background-color #fff
        z-index 11
        border-radius 5px
        box-shadow $modal-shadow
        user-select none
        .hyper-title
            position relative
            height 32px
            width 100%
            background-color #d2d1d1
            color $modal-title-textcolor
            font-size $modal-title-textsize
            border-top-left-radius 5px
            border-top-right-radius 5px
            .item-icon
                position absolute
                width 18px
                height 18px
                left 10px
                top 7px
            .title-text
                position absolute
                left 40px
                font-size 14px
                line-height 32px
            .title-close
                position absolute
                top 4px
                right 5px
                width 25px
                height 25px
                &:hover
                    background-color #92a3d0
                >svg
                    position absolute
                    top 50%
                    left 50%
                    transform translate(-50%, -50%)
                    stroke white
                    width 20px
                    height 20px
</style>

<template>
    <Dialog :title="$t('title')" :showFooter="true" :mask="true" @ok="confirm" @close="cancel">
        <div class="hyperlink-content">
            <div class="hyperlink-left">
                <div class="hyperlink-left-item" @click="setMenu(0)" :class="{ active: selectMenu == 0 }">
                    <iconSymbol class="item-icon" name="hylink-menu1"></iconSymbol>
                    <p class="left-text" :title="$t('nowFile')">{{ $t("nowFile") }}</p>
                </div>
                <div class="hyperlink-left-item" @click="setMenu(1)" :class="{ active: selectMenu == 1 }">
                    <iconSymbol class="item-icon" name="hylink-menu2"></iconSymbol>
                    <p class="left-text" :title="$t('url')">{{ $t("url") }}</p>
                </div>
                <div class="hyperlink-left-item" @click="setMenu(2)" :class="{ active: selectMenu == 2 }">
                    <iconSymbol class="item-icon" name="hylink-menu3"></iconSymbol>
                    <p class="left-text" :title="$t('cloudFile')">{{ $t("cloudFile") }}</p>
                </div>
            </div>
            <div class="hyperlink-right">
                <div
                    class="hyperlink-right-item"
                    :class="{
                        'disable-gray': selectMenu == 0 || hyperlinkList.length == 0,
                        'cloudFile-item': selectMenu === 2,
                        'hyperlink-right-item-en': lang != 'zh',
                    }"
                >
                    <label>{{ $t("location") }}</label>
                    <Input
                        v-model="url"
                        size="small"
                        :disabled="selectMenu == 0 || selectMenu == 2 || hyperlinkList.length == 0"
                        @on-change="changeHyperlink('url')"
                    ></Input>
                    <div v-show="selectMenu === 2" class="btn" :class="{ disable: hyperlinkList.length == 0 }" @click="showCloudFileDialog">
                        {{ $t("importBtn") }}
                    </div>
                </div>
                <div
                    v-show="selectMenu !== 2"
                    class="hyperlink-right-item"
                    :class="{
                        'disable-gray': selectMenu == 1 || hyperlinkList.length == 0,
                        'hyperlink-right-item-en': lang != 'zh',
                    }"
                >
                    <label>{{ $t("page") }}</label>
                    <i-select
                        v-model="page"
                        :placeholder="$t('select')"
                        size="small"
                        @on-change="changeHyperlink('page')"
                        :disabled="selectMenu == 1 || hyperlinkList.length == 0"
                    >
                        <i-option v-for="(item, index) in pageList" :value="item.value" :key="index">{{ item.label }}</i-option>
                    </i-select>
                </div>
                <div
                    v-show="selectMenu !== 2"
                    class="hyperlink-right-item"
                    :class="{
                        'disable-gray': selectMenu == 1 || hyperlinkList.length == 0,
                        'hyperlink-right-item-en': lang != 'zh',
                    }"
                >
                    <label>{{ $t("shape") }}</label>
                    <i-select
                        v-model="shape"
                        :placeholder="$t('select')"
                        size="small"
                        @on-change="changeHyperlink('shape')"
                        :disabled="selectMenu == 1 || hyperlinkList.length == 0"
                    >
                        <i-option :value="-1">{{ $t("none") }}</i-option>
                        <i-option v-for="(item, index) in shapeList" :value="item.value" :key="index">{{ item.label }}</i-option>
                    </i-select>
                </div>
                <div
                    class="hyperlink-right-item"
                    :class="{
                        'disable-gray': hyperlinkList.length == 0,
                        'hyperlink-right-item-en': lang != 'zh',
                    }"
                >
                    <label>{{ $t("description") }}</label>
                    <Input
                        size="small"
                        v-model="des"
                        :placeholder="$t('input')"
                        @on-change="changeHyperlink('des')"
                        :disabled="hyperlinkList.length == 0"
                    ></Input>
                </div>
                <div class="hyperlink-list-box" ref="hyperlink-list-box">
                    <div
                        class="hyperlink-list-item"
                        v-for="(item, index) in hyperlinkList"
                        :key="index"
                        @click="selectListItem(index)"
                        :title="item.des"
                        :class="{ select: index == selectIndex }"
                    >
                        {{ item.des }}
                    </div>
                </div>
                <div class="hyperlink-toolbox">
                    <div @click="addLink()">
                        <iconSymbol class="item-icon" name="property-addAttr"></iconSymbol>
                    </div>
                    <div @click="delLink()">
                        <iconSymbol class="item-icon" name="property-delAttr"></iconSymbol>
                    </div>
                </div>
            </div>
        </div>
    </Dialog>
</template>

<script lang="ts">
    import Sortable from "sortablejs";
    declare var eHyplinkType: any;
    import { Component, Prop, Vue, Watch, Inject } from "vue-property-decorator";
    import Dialog from "./Dialog.vue";
    // @Component 修饰符注明了此类为一个 Vue 组件
    @Component({
        components: {
            Dialog,
        },
    })
    export default class Base extends Vue {
        @Inject()
        ["showMessage"];
        selectMenu = 0;
        address = "";
        selectIndex = 0;
        url = "";
        shape = 0;
        des = "";
        page = 0;
        shapeList = [];
        pageList = [];
        hyperlinkList = [];

        get userInfo() {
            return this.$store.state.user.userInfo;
        }
        get activeFloatItem() {
            return this.$store.state.dialog.activeFloatItem;
        }
        get floatMenuList() {
            return this.$store.state.dialog.floatMenuList;
        }
        get activeShapeID() {
            return this.$store.state.shape.id;
        }
        set activeFloatItem(v) {
            this.$store.commit("setDialogState", {
                type: "activeFloatItem",
                data: v,
            });
        }
        get showHyperlink() {
            return this.$store.state.dialog.showDialog;
        }
        set showHyperlink(data) {
            this.$store.commit("setDialogState", {
                type: "showDialog",
                data: data,
            });
        }
        // 用户偏好
        get customPreferContent() {
            return this.$store.state.ui.customPreferContent;
        }
        set customPreferContent(v) {
            this.$store.commit("setStatus", {
                type: "customPreferContent",
                data: v,
            });
        }

        showCloudFileDialog() {
            this.$store.commit("setDialogState", {
                type: "showCloudFileDialog",
                data: true,
            });
        }

        setInsertLinkCustomPrefer() {
            let data = this.customPreferContent || {};
            if (data["defaultInsertLinkType"] == this.selectMenu) return;
            Object.assign(data, { defaultInsertLinkType: this.selectMenu });
            this.customPreferContent = data;
            let jsonStr = JSON.stringify(data);
            let params = {
                id: this.userInfo.user_id,
                token: this.userInfo.token,
                obj: { content: jsonStr },
            };
            this.$edApi.updateUserPrefer(params);
        }

        cancel() {
            this.showHyperlink = false;
            if (window["_view"]._activeShape && window["_view"]._activeShape.toGantt()) {
                window["_view"]._activeShape.toGantt()._taskIdColIdPair.first = -1;
                window["_view"]._activeShape.toGantt()._taskIdColIdPair.second = -1;
            }

            // 记录用户最后一次点击的链接类型
            this.setInsertLinkCustomPrefer();
            this.activeFloatItem = -1;
        }

        checkUrlNull() {
            let check = false,
                des = undefined;
            for (let [index, link] of Object.entries(this.hyperlinkList)) {
                if (!link.url && (link.type === eHyplinkType.Webpage || link.type === eHyplinkType.cloudFile)) {
                    this.selectListItem(index); // 防止超链接数据丢失
                    check = true;
                    des = link.des;
                    break;
                }
            }
            return check && des;
        }
        checkPageNull() {
            let check = false,
                des = undefined;
            for (let [index, link] of Object.entries(this.hyperlinkList)) {
                if (!link.page && link.type === eHyplinkType.CurrentDoc) {
                    this.selectListItem(index); // 防止超链接数据丢失
                    check = true;
                    des = link.des;
                    break;
                }
            }
            return check && des;
        }
        confirm() {
            if (this.hyperlinkList.length > 0) {
                let pageDes = this.checkPageNull();
                if (pageDes) {
                    let msg = pageDes + " " + this.$t("noNullPage");
                    this.showMessage({
                        type: 1,
                        time: 2,
                        content: msg,
                    });
                    return;
                }
                let urlDes = this.checkUrlNull();
                if (urlDes) {
                    let msg = urlDes + " " + this.$t("noNullURL");
                    this.showMessage({
                        type: 1,
                        time: 2,
                        content: msg,
                    });
                    return;
                }
            }
            this.showHyperlink = false;
            this.$store.commit("setStatus", {
                type: "showDialogMask",
                data: false,
            });
            let hyperlinkList = [];
            this.hyperlinkList.forEach((item) => {
                let obj = {
                    name: item.des,
                    type: item.type - 1, // 配合解析需要
                    url: item.url,
                    page: "",
                    linkName: "",
                };
                if (item.type == eHyplinkType.CurrentDoc) {
                    let pageIndex = 0;
                    window["_view"]._doc._pages.forEach((page, index) => {
                        if (page._id === item.page) {
                            pageIndex = index;
                        }
                    });
                    obj.page = pageIndex + "?" + item.shape;
                }
                if (item.type == eHyplinkType.cloudFile) {
                    obj["notEditable"] = item.notEditable;
                    obj["workId"] = item.workId;
                    item.linkName = item.linkName ? item.linkName : item.url.match(/[^\/]*(?=\.eddx)/i)[0] + ".eddx";
                    obj["linkName"] = item.linkName;
                }
                hyperlinkList.push(obj);
            });
            let id = this.floatMenuList[this.activeFloatItem] ? this.floatMenuList[this.activeFloatItem].id : this.activeShapeID;
            console.log(hyperlinkList, id);
            window["_view"].insertHyperlink(hyperlinkList, id);
            // 记录用户最后一次点击的链接类型
            this.setInsertLinkCustomPrefer();
        }

        reflashShapeList() {
            if (this.page !== null && this.page !== undefined) {
                this.shapeList = [];
                let targetPage = window["_view"]._doc.pageByID(this.page);
                if (targetPage) {
                    this.shapeList = window["_view"].updateShapeList(targetPage);
                } else {
                    this.shapeList = [];
                }
            }
        }

        checkUrlVaild(item) {
            if (item.match(/[^\/]*(?=\.eddx)/i) && item.match(/[^\/]*(?=\.eddx)/i)[0] && item.match(/\/Personal\//i)) {
                return true;
            }
            return false;
        }

        @Watch("selectMenu")
        setUrlVal() {
            switch (this.hyperlinkList[this.selectIndex]?.type) {
                case eHyplinkType.CurrentDoc:
                    this.url = "";
                    !this.page && (this.page = this.pageList[0].value);
                    !this.shape && (this.shape = -1);
                    !this.hyperlinkList[this.selectIndex].page && (this.hyperlinkList[this.selectIndex].page = this.pageList[0].value);
                    !this.hyperlinkList[this.selectIndex].shape && (this.hyperlinkList[this.selectIndex].shape = -1);
                    break;
                case eHyplinkType.cloudFile:
                    this.url = this.checkUrlVaild(this.hyperlinkList[this.selectIndex].url) ? this.hyperlinkList[this.selectIndex].url : "";
                    this.hyperlinkList[this.selectIndex].url = this.url;
                    break;
                case eHyplinkType.Webpage:
                    this.url = !this.checkUrlVaild(this.hyperlinkList[this.selectIndex].url) ? this.hyperlinkList[this.selectIndex].url : "";
                    this.hyperlinkList[this.selectIndex].url = this.url;
                    this.page = 0;
                    this.shape = 0;
                    this.hyperlinkList[this.selectIndex].page = 0;
                    this.hyperlinkList[this.selectIndex].shape = 0;
                    break;
            }
        }

        setMenu(type) {
            this.selectMenu = type;
            if (type == 0 && this.hyperlinkList[this.selectIndex]) {
                this.hyperlinkList[this.selectIndex].type = eHyplinkType.CurrentDoc;
                this.reflashShapeList();
            } else if (type == 1 && this.hyperlinkList[this.selectIndex]) {
                this.hyperlinkList[this.selectIndex].type = eHyplinkType.Webpage;
                this.reflashShapeList();
            } else if (type == 2 && this.hyperlinkList[this.selectIndex]) {
                this.hyperlinkList[this.selectIndex].type = eHyplinkType.cloudFile;
            }
        }

        selectListItem(index) {
            this.selectIndex = index;
            this.url = this.hyperlinkList[this.selectIndex].url;
            this.des = this.hyperlinkList[this.selectIndex].des;
            this.page = this.hyperlinkList[this.selectIndex].page;
            this.shape = this.hyperlinkList[this.selectIndex].shape;
            this.changeSelectLinkItem(this.hyperlinkList[this.selectIndex].type);
        }
        // 重新定位到链接属于的type
        changeSelectLinkItem(type) {
            switch (type) {
                case eHyplinkType.CurrentDoc:
                    this.selectMenu = 0;
                    this.reflashShapeList();
                    break;
                case eHyplinkType.Webpage:
                    this.selectMenu = 1;
                    break;
                case eHyplinkType.cloudFile:
                    this.selectMenu = 2;
                    break;
            }
            this.setUrlVal();
        }

        changeHyperlink(type) {
            switch (type) {
                case "url": {
                    this.hyperlinkList[this.selectIndex]["url"] = this.url;
                    break;
                }
                case "shape": {
                    this.hyperlinkList[this.selectIndex]["shape"] = this.shape;
                    break;
                }
                case "des": {
                    this.hyperlinkList[this.selectIndex]["des"] = this.des;
                    this.hyperlinkList[this.selectIndex]["linkName"] = this.des;
                    break;
                }
                case "page": {
                    this.hyperlinkList[this.selectIndex]["page"] = this.page;
                    this.reflashShapeList();
                    break;
                }
            }
        }

        addLink() {
            let type = eHyplinkType.CurrentDoc;
            let page = null;
            let shape = 0;
            switch (this.selectMenu) {
                case 0:
                    type = eHyplinkType.CurrentDoc;
                    // 添加默认选中值
                    page = this.pageList[0].value;
                    shape = -1;
                    break;
                case 1:
                    type = eHyplinkType.Webpage;
                    break;
                case 2:
                    type = eHyplinkType.cloudFile;
                    break;
            }
            let link = {
                des: (this.$t("link") as string) + (this.hyperlinkList.length + 1),
                url: "",
                page,
                shape,
                type,
                linkName: "",
            };
            // this.selectMenu = 1
            this.hyperlinkList.push(link);
            this.selectIndex = this.hyperlinkList.length - 1;
            this.url = link.url;
            this.des = link.des;
            this.page = link.page;
            this.shape = link.shape;
            this.reflashShapeList();
            // 滚动到对应的位置
            this.$nextTick(() => {
                let scrollTop = (document.querySelector(".hyperlink-list-item.select") as HTMLElement).offsetTop;
                let scrollDom = this.$refs["hyperlink-list-box"] as HTMLElement;
                if (scrollTop >= scrollDom.offsetHeight) {
                    scrollDom.scrollTo(0, scrollTop);
                }
            });
        }

        delLink() {
            if (this.hyperlinkList.length > 0) {
                this.hyperlinkList.splice(this.selectIndex, 1);
                this.selectIndex = this.hyperlinkList.length - 1;
                if (this.hyperlinkList.length > 0) {
                    this.url = this.hyperlinkList[this.selectIndex].url;
                    this.des = this.hyperlinkList[this.selectIndex].des;
                    this.page = this.hyperlinkList[this.selectIndex].page;
                    this.shape = this.hyperlinkList[this.selectIndex].shape;
                    this.reflashShapeList();
                    if (this.hyperlinkList[this.selectIndex].type == eHyplinkType.CurrentDoc) {
                        this.selectMenu = 0;
                    } else if (this.hyperlinkList[this.selectIndex].type == eHyplinkType.Webpage) {
                        this.selectMenu = 1;
                    } else if (this.hyperlinkList[this.selectIndex].type == eHyplinkType.cloudFile) {
                        this.selectMenu = 2;
                    }
                } else {
                    this.url = "";
                    this.des = "";
                    this.page = null;
                    this.shape = 0;
                    this.selectMenu = 0;
                }
            }
        }

        //生命周期
        mounted() {
            let hyperlinkList = [];
            if (this.activeFloatItem != -1) {
                hyperlinkList = this.floatMenuList[this.activeFloatItem]?.hyperlinkList?._hyperlinks || [];
            } else if (this.activeShapeID != 0) {
                for (let i = 0; i < this.floatMenuList.length; ++i) {
                    if (this.floatMenuList[i].id == this.activeShapeID) {
                        hyperlinkList = this.floatMenuList[i].hyperlinkList._hyperlinks;
                        break;
                    }
                }
            }

            let ts = this;
            let sortable = new Sortable(this.$refs["hyperlink-list-box"], {
                onEnd(event) {
                    let hyperlinkListTemp = ts.hyperlinkList[event.oldIndex];
                    ts.hyperlinkList[event.oldIndex] = ts.hyperlinkList[event.newIndex];
                    ts.hyperlinkList[event.newIndex] = hyperlinkListTemp;
                },
            });

            let view = window["_view"];
            if (view._activeShape && view._activeShape.toGantt()) {
                let gantt = view._activeShape.toGantt();
                let ganttcell = view._activeShape.toGantt().getCellWithRowColPair(gantt._taskIdColIdPair);
                if (ganttcell) {
                    hyperlinkList = ganttcell._hypLinks._hyperlinks;
                }
                console.log("没有选择超链接单元格");
            }

            hyperlinkList.forEach((item) => {
                let obj = {};
                if (item._type == eHyplinkType.CurrentDoc) {
                    let pageName = item._subAddress.split("?")[0];
                    let page = window["_view"]._doc.pageByName(pageName);
                    obj["page"] = page && page._id;
                    let shape = item._subAddress.split("?")[1];
                    obj["shape"] = +shape;
                } else if (item._type == eHyplinkType.Webpage) {
                    obj["page"] = null;
                    obj["shape"] = null;
                }
                obj["url"] = item._address;
                obj["des"] = item._description;
                obj["type"] = item._type;
                obj["workId"] = item._workId || 0;
                obj["linkName"] = item._linkName || "";
                this.hyperlinkList.push(obj);
            });
            if (this.hyperlinkList[this.selectIndex]) {
                this.url = this.hyperlinkList[this.selectIndex].url;
                this.des = this.hyperlinkList[this.selectIndex].des;
                this.page = this.hyperlinkList[this.selectIndex].page;
                this.shape = this.hyperlinkList[this.selectIndex].shape;
                if (this.hyperlinkList[this.selectIndex].type == eHyplinkType.Webpage) {
                    this.selectMenu = 1;
                }
            }

            if (this.hyperlinkList.length == 0) {
                let link = {
                    des: (this.$t("link") as string) + (this.hyperlinkList.length + 1),
                    url: "",
                    type: eHyplinkType.Webpage,
                };
                this.selectMenu = 1;
                this.hyperlinkList.push(link);
                this.selectIndex = this.hyperlinkList.length - 1;
                this.url = link.url;
                this.des = link.des;
                // 根据用户最后一次点击的链接类型选中对应的tab
                let customPreferContentObj = this.customPreferContent;
                let map = new Map([
                    [0, eHyplinkType.CurrentDoc],
                    [1, eHyplinkType.Webpage],
                    [2, eHyplinkType.cloudFile],
                ]);
                let type = (customPreferContentObj && customPreferContentObj["defaultInsertLinkType"]) || 1;
                this.changeSelectLinkItem(map.get(type));
            } else {
                // 根据已有的链接类型选中对应的tab
                this.changeSelectLinkItem(this.hyperlinkList[this.selectIndex].type);
            }

            let pageList = window["_view"]._doc.pageIds();
            pageList.forEach((item) => {
                let obj = {
                    label: window["_view"]._doc.pageByID(item)._name,
                    value: item,
                };
                this.pageList.push(obj);
            });
            this.reflashShapeList();
            this.$bus.$on("changeCloudFileUrl", (obj) => {
                this.$nextTick(() => {
                    let { item, workId = 0 } = obj;
                    let url = item.obj || item.key;
                    url = url.slice(url.indexOf("/"));
                    this.hyperlinkList[this.selectIndex].type = eHyplinkType.cloudFile;
                    this.hyperlinkList[this.selectIndex].url = url;
                    this.hyperlinkList[this.selectIndex].notEditable = !(item.info && item.info.edit);
                    this.hyperlinkList[this.selectIndex].workId = workId;
                    this.selectListItem(this.selectIndex);
                });
            });
        }

        created() {}

        beforeDestroy() {
            this.$bus.$off("changeCloudFileUrl");
        }
    }
</script>
<i18n>
{
  "zh": {
    "title": "超链接",
    "nowFile": "当前文档",
    "url": "网址",
    "cloudFile": "云文档",
    "location": "地址：",
    "shape": "形状：",
    "page": "页码：",
    "importBtn": "浏览",
    "description": "描述：",
    "link": "超链接",
    "new": "新建",
    "del": "删除",
    "input": "请输入",
    "none": "无",
    "noNullURL": "地址不可为空",
    "noNullPage": "页码不可为空",
    "noNullShape": "形状不可为空",
    "select": "请选择"
  },
  "en": {
    "title": "Hyperlink",
    "nowFile": "Current Document",
    "url": "URL",
    "cloudFile": "Cloud Documents",
    "location": "Location:",
    "shape": "Shape:",
    "page": "Page:",
    "importBtn": "Browse",
    "description": "Description:",
    "link": "Link",
    "new": "Create",
    "del": "Delete",
    "input": "Please enter",
    "none": "None",
    "select": "Please select",
    "noNullURL": "URL cannot be empty",
    "noNullPage": "Page number cannot be empty",
    "noNullShape": "Shape cannot be empty"
  },
  "jp": {
    "title": "ハイパーリンク",
    "nowFile": "現在のドキュメント",
    "url": "インターネットアドレス",
    "cloudFile": "クラウドファイル",
    "location": "アドレス：",
    "shape": "形状：",
    "page": "ページ：",
    "importBtn": "参照",
    "description": "説明：",
    "link": "ハイパーリンク",
    "new": "新規作成",
    "del": "削除",
    "input": "入力してください...",
    "none": "なし",
    "noNullURL": "アドレスは空にできません",
    "noNullPage": "ページ番号は空にできません",
    "noNullShape": "形状を空にすることはできません",
    "select": "選択してください"
  },
  "fr": {
    "title": "Hyperlien",
    "nowFile": "Document Actuel",
    "url": "URL",
    "cloudFile": "Documents Cloud",
    "location": "Location:",
    "shape": "Forme:",
    "page": "Page:",
    "importBtn": "Parcourir",
    "description": "Description:",
    "link": "Hyperlien",
    "new": "Nouveau",
    "del": "Effacer",
    "input": "Veuillez entrer",
    "none": "Aucun",
    "noNullURL": "URL ne peut pas être vide",
    "noNullPage": "Numéro de page ne peut pas être vide",
    "noNullShape": "Forme ne peut pas être vide",
    "select": "Veuillez Sélectionner"
  },
  "de": {
    "title": "Hyperlink",
    "nowFile": "Aktuelles Dokument",
    "url": "URL",
    "cloudFile": "Cloud-Dokumente",
    "location": "Ort：",
    "shape": "Form：",
    "page": "Seite：",
    "importBtn": "Browsen",
    "description": "Beschreibung：",
    "link": "Hyperlink",
    "new": "Neu erstellen",
    "del": "Löschen",
    "input": "Bitte eingeben",
    "none": "Keine",
    "noNullURL": "URL darf nicht leer sein",
    "noNullPage": "Seitenzahl darf nicht leer sein",
    "noNullShape": "Form darf nicht leer sein",
    "select": "Bitte auswählen"
  },
  "es": {
    "title": "Hipervínculo",
    "nowFile": "Documento actual",
    "url": "url",
    "cloudFile": "Documentos en la nube",
    "location": "Ubicación",
    "shape": "Forma",
    "page": "Página",
    "importBtn": "Examinar",
    "description": "Descripción",
    "link": "Hipervínculo",
    "new": "Crear",
    "del": "Borrar",
    "input": "Por favor, introduzca",
    "none": "Ninguno",
    "noNullURL": "La URL no puede estar vacía",
    "noNullPage": "El número de página no puede estar vacío",
    "noNullShape": "La forma no puede estar vacía",
    "select": "Por favor, seleccione"
  },
  "pt": {
    "title": "Hiperligação",
    "nowFile": "Documento Atual",
    "url": "URL",
    "cloudFile": "Documentos em Nuvem",
    "location": "Localização:",
    "shape": "Forma:",
    "page": "Página:",
    "importBtn": "Navegar",
    "description": "Descrição:",
    "link": "Ligação",
    "new": "Criar",
    "del": "Eliminar",
    "input": "Por favor, inserir",
    "none": "Nenhum",
    "select": "Por favor, selecionar",
    "noNullURL": "URL não pode estar vazio",
    "noNullPage": "Número de página não pode estar vazio",
    "noNullShape": "Forma não pode estar vazia"
  },
  "it": {
    "title": "Collegamento",
    "nowFile": "Documento Corrente",
    "url": "URL",
    "cloudFile": "Documenti Cloud",
    "location": "Posizione:",
    "shape": "Forma:",
    "page": "Pagina:",
    "importBtn": "Sfoglia",
    "description": "Descrizione:",
    "link": "Collegamento",
    "new": "Crea",
    "del": "Elimina",
    "input": "Si prega di immettere",
    "none": "Nessuno",
    "select": "Si prega di selezionare",
    "noNullURL": "Si prega di riempire il campo URL",
    "noNullPage": "Si prega di immettere il numero di pagina",
    "noNullShape": "Si prega di selezionare una forma"
  },
  "tw": {
    "title": "超連結",
    "nowFile": "當前檔案",
    "url": "網址",
    "cloudFile": "雲文檔",
    "location": "地址：",
    "shape": "形狀：",
    "page": "頁碼：",
    "importBtn": "瀏覽",
    "description": "描述：",
    "link": "超連結",
    "new": "新建",
    "del": "刪除",
    "input": "請輸入",
    "none": "無",
    "noNullURL": "地址不可為空",
    "noNullPage": "頁碼不可為空",
    "noNullShape": "形狀不可為空",
    "select": "請選擇"
  },
  "kr": {
    "title": "하이퍼링크",
    "nowFile": "현재 문서",
    "url": "URL",
    "cloudFile": "클라우드 파일",
    "location": "위치:",
    "shape": "모양:",
    "page": "페이지:",
    "importBtn": "찾아보기",
    "description": "설명:",
    "link": "하이퍼링크",
    "new": "새로 만들기",
    "del": "삭제",
    "input": "입력하세요",
    "none": "무",
    "noNullURL": "URL은 비워 둘 수 없습니다.",
    "noNullPage": "페이지 번호는 비워 둘 수 없습니다.",
    "noNullShape": "모양는 비워 둘 수 없습니다.",
    "select": "선택해주십시오."
  }
}
</i18n>
